import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  Redirect,
} from 'react-router-dom'
import cn from 'classnames'

import style from '@src/pages/Registration/Registration.module.scss'
import { Title } from '@src/components/Title/Title'
// import { TabList } from '@src/components/Tablist/TabList'
import { RegistrationForm } from '@src/pages/Registration/RegistrationForm'
import {
  selectIsAuth,
  selectIsLoading,
  selectRegisterSuccess,
} from '@src/store/ducks/auth/selectors'

import { resetState } from '@src/store/ducks/auth/reducer'
import { AppDispatch } from '@src/store/store'
import { ReturnBtn } from '@src/components/Button/ReturnBtn'
import { setPageTitle } from '@src/store/ducks/app/reducer'
import useQuery from '@src/hooks/useQuery'

/* const tabListOptions:Array<{ url: string, title: string }> = [
  {
    url: '/registration/phone',
    title: 'По номеру телефона',
  },
] */
export const Registration = () => {
  const dispatch = useDispatch<AppDispatch>()
  const registerSuccess = useSelector(selectRegisterSuccess)
  const isLoading = useSelector(selectIsLoading)
  const isTv = useQuery('tv')
  const isAuth = useSelector(selectIsAuth)

  useEffect(() => { dispatch(setPageTitle('Регистрация пользователя')) }, [dispatch])

  useEffect(() => () => { dispatch(resetState()) }, [dispatch])

  if (registerSuccess || isAuth) {
    return <Redirect to="/login/phone" />
  }
  return (
    <div id="login" className={cn(style.registration, 'container')}>
      <div className={style.registration__body}>
        {!isTv && (
          <div className={` ${style.return}`}>
            <ReturnBtn type="secondary">Вернуться</ReturnBtn>
          </div>
        )}
        <Title title="Регистрация пользователя" />
        <div className={style.body}>
          <div>
            {/* <TabList options={tabListOptions} /> */}
            <RegistrationForm isLoading={isLoading} />
          </div>
        </div>
      </div>
    </div>
  )
}
